var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWrong = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.9619,
    height: 11.9993,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 11.9619 11.9993",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E82A53",
    d: "M11.6628 10.4666q.5233.6355 0 1.271-.6354.5234-1.271 0L5.9809 7.2893l-4.4483 4.4483q-.6354.5234-1.271 0-.5232-.6355 0-1.271L4.71 6.0183.2617 1.5326q-.5235-.6354 0-1.271.6354-.5232 1.271 0l4.4482 4.4857L10.4292.299q.6355-.5232 1.271 0 .5233.6356 0 1.271L7.2519 6.0183z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWrong);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wrong.200cbd3d6e87ba36a333dced7b820782.svg";